// App version shown in the footer.
//
// This file is regenerated automatically by scripts/gen-version.js, which runs
// before `npm start` and `npm run build` (see package.json prestart/prebuild).
// The patch number is derived from the number of git commits past a baseline,
// so the version auto-bumps every time a new commit is pushed:
//   v5.0.0 at the baseline, v5.0.1 after the next commit, and so on.
export const APP_VERSION = "5.0.0";
